
import _ from "lodash";
import { projectTypes } from "constants/projectTypes";
import hedgeTypes from "constants/hedgeTypes";
import { map } from "constants/screenElements/soldDealTable";

import {
  formatDisplayValue,
  formatCurrency,
  formatInteger,
  formatRate,
  formatMonths,
  formatYears,
  formatDaysToYears,
  formatDate,
  formatNumberTwoDecimal,
  notImplemented,
  formatCurrencyTwoDecimal,
  formatDecimalNoDecimal,
  formatNumberOneDecimal
} from "./formattersv2";

const {
  CASH_EQUITY,
  BROKER_COMPANY,
  MSA,
  HOLD_PERIOD_YEARS,
  EXIT_CAP,
  LOAN_BALANCE_AT_EXIT,
  PREPAYMENT,
  STATE,
  CITY,
  ASSET_CLASS,
  ASSET_TYPE,
  SALES_PRICE,
  EXIT_DATE
} = map;

export default {
  [CASH_EQUITY]: formatCurrency,
  [BROKER_COMPANY]: notImplemented,
  [MSA]: formatDisplayValue,
  [HOLD_PERIOD_YEARS]: data => {
    const val = data;
    if (val) {
      return val.toFixed(0);
    }

    return "-";
  },
  [EXIT_CAP]: formatRate,
  [LOAN_BALANCE_AT_EXIT]: notImplemented,
  [PREPAYMENT]: formatCurrency,
  [STATE]: formatDisplayValue,
  [CITY]: formatDisplayValue,
  [ASSET_CLASS]: formatDisplayValue,
  [ASSET_TYPE]: formatDisplayValue,
  [SALES_PRICE]: formatCurrency,
  [EXIT_DATE]: formatDate
};
